import { render, staticRenderFns } from "./DashboardContent.vue?vue&type=template&id=2053e3f2"
import script from "./DashboardContent.vue?vue&type=script&lang=js"
export * from "./DashboardContent.vue?vue&type=script&lang=js"
import style0 from "./DashboardContent.vue?vue&type=style&index=0&id=2053e3f2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2053e3f2')) {
      api.createRecord('2053e3f2', component.options)
    } else {
      api.reload('2053e3f2', component.options)
    }
    module.hot.accept("./DashboardContent.vue?vue&type=template&id=2053e3f2", function () {
      api.rerender('2053e3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/dashboard_content/DashboardContent.vue"
export default component.exports